import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormSpecialFactors } from "../Models/Forms/IFormSpecialFactors";

@Injectable()
export class FormSpecialFactorsService extends BaseService  {
  _baseUrl: string = "";


  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }
 

  getFormSpecialFactors(id: number) {
    return this._http.get(this._baseUrl + "api/FormSpecialFactors/" + id)
      .map((response: IFormSpecialFactors) => response as IFormSpecialFactors)
      .catch(this.errorHandler);
  }

  insertUpdateFormSpecialFactors(formSpecialFactorsDetails: IFormSpecialFactors) {
    return this._http.post(this._baseUrl + 'api/FormSpecialFactors', formSpecialFactorsDetails)
      .map((response: IFormSpecialFactors) => response as IFormSpecialFactors)
      .catch(this.errorHandler);
  }

  deleteSpecialFactors(id) {
    return this._http.delete(this._baseUrl + "api/FormSpecialFactors" + id)
      .map((response: IFormSpecialFactors) => response as IFormSpecialFactors)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}

